import React, { ReactElement } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { getNetworksDataset } from "redux/selectors/networksSelector";

const NetworkRecap = (): ReactElement => {
 const params = useParams<{ id: string; section: string }>();
 const networkData = useSelector(getNetworksDataset).find(
  (element) => element.id === Number(params.id)
 );

 return (
  <Paper elevation={1} sx={{ borderRadius: "5px", p: 2 }}>
   <Stack>
    <Typography
     fontWeight="bold"
     fontSize={16}
     textAlign="left"
     textTransform="uppercase"
     variant="unboundedTitle">
     {networkData?.name || "N/A"}
    </Typography>
   </Stack>
  </Paper>
 );
};

export default NetworkRecap;
